import addModal from './addModal.vue';
import { currencyList } from '../request';
export default {
  components: {
    addModal
  },
  data() {
    return {
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        page: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      form: {
        name: ''
      },
      addVisible: false,
      isEdit: false,
      tableData: [{
        id: 1
      }],
      columns: [{
        slots: {
          title: '货币代码'
        },
        dataIndex: 'code',
        key: 'code',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '货币名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '货币单位（主）'
        },
        dataIndex: 'unit',
        key: 'unit',
        align: 'center'
      }, {
        slots: {
          title: '货币符号'
        },
        dataIndex: 'symbol',
        key: 'symbol',
        align: 'center'
      }, {
        slots: {
          title: '金额精度'
        },
        dataIndex: 'amountAccuracy',
        key: 'amountAccuracy',
        align: 'center'
      }, {
        slots: {
          title: '单位精度'
        },
        dataIndex: 'unitAccuracy',
        key: 'unitAccuracy',
        width: 160,
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 180,
        scopedSlots: {
          customRender: 'operation'
        }
      }]
    };
  },
  created() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await currencyList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    reset() {
      this.form = {
        name: ''
      };
    }
  }
};